import Marquee from "react-fast-marquee";
import { useLang } from "../../i18n/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLang();
  return (
    <div className="editorial-marquee bg-white py-6 md:py-8" data-testid="marquee">
      <Marquee speed={45} gradient={false} autoFill>
        {t.marquee.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="uppercase text-sm md:text-base tracking-[0.2em] font-bold px-5">
              {item}
            </span>
            <span className="text-xs md:text-sm">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
